module.exports = __webpack_public_path__ + "img/7.49526891.svg";